import { render, staticRenderFns } from "./MnvValidationTable.vue?vue&type=template&id=1c60e005&scoped=true"
import script from "./MnvValidationTable.vue?vue&type=script&lang=js"
export * from "./MnvValidationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c60e005",
  null
  
)

export default component.exports